export const PRINT_AGENT_CONFIG = {
  downloadUrl: '/print-agent/PrintAgent.exe',
  fileName: 'PrintAgent.exe',
  /** Bundan eski agentda printer holati va ishlar navbati ishlamaydi. */
  minVersion: '1.1.0',
  /** Shu vaqt ichida bir hujjat qayta yuborilsa, tasdiqlash so'raladi. */
  duplicateWindowMs: 2 * 60 * 1000,
  /** Printerlar ro'yxatini yangilash: hamma narsa tinch bo'lsa. */
  printersPollIdleMs: 15000,
  /** Ish ketayotgan yoki tanlangan printer band bo'lsa. */
  printersPollActiveMs: 3000,
  /** Agent topilmasa — ishga tushirilganini sezish uchun. */
  printersPollNoAgentMs: 10000,
  jobsPollMs: 2000,
  /** Hamma ish tugagach vidjet shuncha vaqtdan keyin yopiladi. */
  widgetAutoHideMs: 10000,
};
